import { ComponentProps } from 'react';

export function LinkedinIcon({ className, ...props }: ComponentProps<'svg'>) {
	return (
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
			<circle cx="15" cy="15" r="14.5" stroke="currentColor" />
			<path
				d="M12.1107 8.55739C12.1107 9.41395 11.5656 10.1148 10.5533 10.1148C9.62295 10.1107 9 9.40985 9 8.63526C9 7.77869 9.62295 7 10.5574 7C11.4918 7 12.1148 7.70082 12.1148 8.55739H12.1107Z"
				fill="currentColor"
			/>
			<path d="M12.1107 10.8896H9V21.0004H12.1107V10.8896Z" fill="currentColor" />
			<path
				d="M19.578 11.0451C17.9427 11.0451 17.0124 11.9795 16.623 12.6025H16.5451L16.3894 11.2787H13.5902C13.5902 12.1353 13.6681 13.1435 13.6681 14.3115V21.0001H16.7788V15.4796C16.7788 15.1681 16.7788 14.9345 16.8566 14.7009C17.0902 14.1558 17.4796 13.455 18.3361 13.455C19.4263 13.455 19.8935 14.3894 19.8935 15.6312V20.996H23.0042V15.2419C23.0042 12.3648 21.5247 11.041 19.5821 11.041L19.578 11.0451Z"
				fill="currentColor"
			/>
		</svg>
	);
}
